import React from 'react'
import { Box, Typography } from '@mui/material'
import FixedWidthContainer from 'components/FixedWidthContainer'
import DealerSignupSection from 'components/DealerSignupSection'
import SectionHeader from 'components/SectionHeader'
import { useTranslation } from 'react-i18next'

const ReturnRefundPolicyPage = () => {
  const { t } = useTranslation()
  return (
    <Box sx={{ minHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
      <FixedWidthContainer sx={{ pb: 8 }}>
        <SectionHeader title={t('returnRefundPolicy.title')} />

        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('returnRefundPolicy.intro')}
        </Typography>
        <Typography
          variant='body1'
          sx={{ mt: 4, color: '#7C7C7C' }}
          gutterBottom
        >
          {t('returnRefundPolicy.authorization')}{' '}
          <Box
            component='span'
            sx={{ color: 'primary.main', cursor: 'pointer' }}
            onClick={() =>
              (window.location.href = 'mailto:claims_ca@musescabinets.com')
            }
          >
            {t('returnRefundPolicy.westCoastEmail')}
          </Box>{' '}
          {t('returnRefundPolicy.westCoast')}{' '}
          <Box
            component='span'
            sx={{ color: 'primary.main', cursor: 'pointer' }}
            onClick={() =>
              (window.location.href = 'mailto:claims_ga@musescabinets.com')
            }
          >
            {t('returnRefundPolicy.eastCoastEmail')}
          </Box>{' '}
          {t('returnRefundPolicy.eastCoast')}
        </Typography>
        <Typography
          variant='body1'
          sx={{ mt: 4, color: '#7C7C7C' }}
          gutterBottom
        >
          {t('returnRefundPolicy.timeLimit')}
        </Typography>
        <Typography
          variant='body1'
          sx={{ mt: 4, color: '#7C7C7C' }}
          gutterBottom
        >
          {t('returnRefundPolicy.conditions')}
        </Typography>
        <Typography
          variant='body1'
          sx={{ mt: 4, color: '#7C7C7C' }}
          gutterBottom
        >
          {t('returnRefundPolicy.restockingFee')}
        </Typography>
        <Typography
          variant='body1'
          sx={{ mt: 4, color: '#7C7C7C' }}
          gutterBottom
        >
          {t('returnRefundPolicy.creditOrRefund')}
        </Typography>
        <Typography variant='body1' sx={{ mt: 4, color: '#7C7C7C' }}>
          {t('returnRefundPolicy.refundProcess')}
        </Typography>
      </FixedWidthContainer>
      <Box sx={{ mt: 'auto' }}>
        <DealerSignupSection />
      </Box>
    </Box>
  )
}

export default ReturnRefundPolicyPage
